import { TopBaseTheme } from '@talentinc/gatsby-theme-ecom/themes/top'

export const TopCVCoUKTheme = TopBaseTheme

export default TopCVCoUKTheme
